import RequestBase from '../Resources/RequestBase';

export default class GetDocumentRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Documents/{documentTypeId}/{documentId}';
        this.method = 'GET';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = { data: 'There should be a document here.' };
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Documents.js